import Cookies from 'js-cookie';
import { GDPR_GA } from 'constants/cookieGdpr';

export const trackDownloadFirmware = () => {
  if (!!Cookies.get(GDPR_GA) && window.ga) {
    window.ga('send', 'event', 'download_firmware', 'download_firmware_button', {
      transport: 'beacon',
    });
  }
};
